import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const Hipass = () => {
  

  const features = [
    {
      title: '충격 흡수 구조 적용',
      bullets: [
      {
        label: (
          <>차량 충돌 시 충격을 효과적으로 분산·흡수하여 시설물 파손과 인명 피해를 최소화함</>
        ),
      },
      ]
    },
    {
      title: '근무자 안전 강화 설계',
      bullets: [
      {
        label: (
          <>하이패스 차로에서 근무하는 직원들을 직접적인 차량 위협으로부터 보호해 안전한 업무 환경을 조성함</>
        ),
      },
      ]
    },
    {
      title: '운전자 보호 기능',
      bullets: [
      {
        label: (
          <>운전자 시야 확보와 차로 유도 기능을 통해 예기치 않은 충돌을 예방하고 안전한 주행을 지원함</>
        ),
      },
      ]
    },
    {
      title: '고내구성 소재 사용',
      bullets: [
      {
        label: (
          <>외부 환경 변화(비·눈·미세먼지 등)에 강한 재질을 사용해 장기간 안정적으로 유지되며, 유지보수 비용도 절감할 수 있음</>
        ),
      },
      ]
    },
    {
      title: '교통 흐름 유지',
      bullets: [
      {
        label: (
          <>차량 이동을 방해하지 않는 구조로 설계되어 고속 주행 환경에서도 원활한 흐름을 유지함</>
        ),
      },
      ]
    },
    {
      title: '유지관리 편의성',
      bullets: [
      {
        label: (
          <>간편한 설치 방식과 모듈 교체가 가능한 구조로 유지보수 비용 절감 및 관리 효율성을 확보함</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`하이패스 안전시설물`}
        subtitle={`차량 충돌 위험을 대비하여 \n사고 피해를 최소화합니다`}
        backgroundImage="/images/products/guardrail/hi-pass2.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '하이패스 안전시설물' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`차세대 교통안전 솔루션`}
        title={`하이패스 안전시설물`}
        description={
          <>
            하이패스 차로에서 근무자와 운전자를 차량 충돌 위험으로부터 보호하기 위해 설치되는 필수 안전장치입니다.
            <br />
            <br />
            견고한 구조와 충격 흡수 기능을 통해 사고로 인한 피해를 최소화하며, 동시에 교통 흐름을 방해하지 않고 안전한 통행 환경을 제공합니다.
          </>
        }
        images={[
          '/images/products/guardrail/hi-pass5.jpg',
          '/images/products/guardrail/hi-pass2.jpg',
          '/images/products/guardrail/hi-pass3.jpg',
          '/images/products/guardrail/hi-pass4.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/hi-pass"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default Hipass;
